/**
 * @generated SignedSource<<6a135c14e8c606efe6e3d96f434dfdcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActionItemGroupsListMoveActionItemMutation$variables = {
  groupId: string;
  includeAiDetected?: boolean | null;
  includeCompleted?: boolean | null;
  includeWontDo?: boolean | null;
  noteBlockId: string;
  orderInsertedAfter?: string | null;
  orderInsertedBefore?: string | null;
};
export type ActionItemGroupsListMoveActionItemMutation$data = {
  readonly moveActionItemToGroup: {
    readonly actionItemGroups: ReadonlyArray<{
      readonly id: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        } | null>;
      };
    }> | null;
    readonly updatedBlock: {
      readonly id: string;
      readonly userOrderWithinGroup: string | null;
    };
  } | null;
};
export type ActionItemGroupsListMoveActionItemMutation$rawResponse = {
  readonly moveActionItemToGroup: {
    readonly actionItemGroups: ReadonlyArray<{
      readonly id: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        } | null>;
      };
    }> | null;
    readonly updatedBlock: {
      readonly id: string;
      readonly userOrderWithinGroup: string | null;
    };
  } | null;
};
export type ActionItemGroupsListMoveActionItemMutation = {
  rawResponse: ActionItemGroupsListMoveActionItemMutation$rawResponse;
  response: ActionItemGroupsListMoveActionItemMutation$data;
  variables: ActionItemGroupsListMoveActionItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAiDetected"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCompleted"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWontDo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteBlockId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedAfter"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedBefore"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "groupId",
        "variableName": "groupId"
      },
      {
        "kind": "Variable",
        "name": "noteBlockId",
        "variableName": "noteBlockId"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedAfter",
        "variableName": "orderInsertedAfter"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedBefore",
        "variableName": "orderInsertedBefore"
      }
    ],
    "concreteType": "MoveActionItemToGroup",
    "kind": "LinkedField",
    "name": "moveActionItemToGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "updatedBlock",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userOrderWithinGroup",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ActionItemGroupNode",
        "kind": "LinkedField",
        "name": "actionItemGroups",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "includeAiDetected",
                "variableName": "includeAiDetected"
              },
              {
                "kind": "Variable",
                "name": "includeCompleted",
                "variableName": "includeCompleted"
              },
              {
                "kind": "Variable",
                "name": "includeWontDo",
                "variableName": "includeWontDo"
              }
            ],
            "concreteType": "ActionItemGroupNoteBlockConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ActionItemGroupNoteBlockEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteBlock",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemGroupsListMoveActionItemMutation",
    "selections": (v8/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActionItemGroupsListMoveActionItemMutation",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "07d3df352309c6982314c30b343ba66c",
    "id": null,
    "metadata": {},
    "name": "ActionItemGroupsListMoveActionItemMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemGroupsListMoveActionItemMutation(\n  $noteBlockId: ID!\n  $groupId: ID!\n  $orderInsertedBefore: String\n  $orderInsertedAfter: String\n  $includeCompleted: Boolean\n  $includeWontDo: Boolean\n  $includeAiDetected: Boolean\n) {\n  moveActionItemToGroup(noteBlockId: $noteBlockId, groupId: $groupId, orderInsertedBefore: $orderInsertedBefore, orderInsertedAfter: $orderInsertedAfter) {\n    updatedBlock {\n      id\n      userOrderWithinGroup\n    }\n    actionItemGroups {\n      id\n      items(includeCompleted: $includeCompleted, includeWontDo: $includeWontDo, includeAiDetected: $includeAiDetected) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "47d7745be2e0e15beae5012578f529e8";

export default node;
